import styled from "styled-components"

import {greys, perkbox} from "@irati/ui/src/global/colors"
import {DosisBold} from "@irati/ui/src/global/fonts"

export default styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: ${perkbox.darkBlue};
  color: ${greys.white};
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${DosisBold}
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.34);
`
